import React, { useState, useCallback, useEffect } from 'react';
import { useEventListener } from '@24i/player-utils-react';
import { Slider } from '@react-native-assets/slider';
import { dragSeekingEnded, dragSeekingStarted, usePlayerUIContext, hideUI } from '@24i/player-ui';
const PERCENT = 100;
const sliderStyle = {
    position: 'absolute',
    width: '100%',
    marginTop: 20,
    marginBottom: 20,
    top: -50,
    left: 0,
    height: 50,
};
const thumbStyle = {
    visibility: 'hidden',
};
export const SeekingManager = ({ parentElement, onSeekingProgress, onSeekingStart, onSeekingEnd, onHoverStart, onHoverEnd, isSeekingDisabled, value, setValue, setHoverProgress, }) => {
    const [isGestureInProgress, setIsGestureInProgress] = useState(false);
    const [isChangingValue, setIsChangingValue] = useState(false);
    const [isHovering, setIsHovering] = useState(false);
    const { dispatch } = usePlayerUIContext();
    const getAndReportProgress = useCallback(({ pageX }) => {
        if (!parentElement || pageX === undefined)
            return;
        const { left, width } = parentElement.getBoundingClientRect();
        const progress = ((pageX - left) / width) * PERCENT;
        const progressInPercent = Math.max(0, Math.min(PERCENT, progress));
        onSeekingProgress(progressInPercent);
    }, [parentElement, onSeekingProgress]);
    const preventEvent = useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
    }, []);
    const onGestureStarted = useCallback(() => {
        setIsGestureInProgress(true);
        onSeekingStart();
        dispatch(dragSeekingStarted());
    }, [setIsGestureInProgress, onSeekingStart]);
    const onGestureEnded = useCallback(() => {
        setIsGestureInProgress(false);
        onSeekingEnd();
        dispatch(dragSeekingEnded());
    }, [onSeekingEnd, setIsGestureInProgress]);
    const onMouseDown = useCallback((event) => {
        if (isSeekingDisabled)
            return;
        preventEvent(event);
        onGestureStarted();
        getAndReportProgress(event);
    }, [preventEvent, onGestureStarted, getAndReportProgress, isSeekingDisabled]);
    const onMouseMove = useCallback((event) => {
        if (isGestureInProgress || isHovering) {
            preventEvent(event);
            getAndReportProgress(event);
        }
    }, [isGestureInProgress, isHovering, preventEvent, getAndReportProgress]);
    const onMouseUp = useCallback((event) => {
        if (isGestureInProgress)
            preventEvent(event);
    }, [isGestureInProgress, preventEvent]);
    const onClick = useCallback((event) => {
        if (isGestureInProgress) {
            preventEvent(event);
            onGestureEnded();
        }
    }, [isGestureInProgress, preventEvent, onGestureEnded]);
    const onValueChange = useCallback((newValue) => {
        setValue(newValue);
        onSeekingProgress(newValue);
    }, [setValue, onSeekingProgress]);
    const onMouseLeave = useCallback(() => {
        setIsHovering(false);
        onHoverEnd();
    }, [onHoverEnd]);
    useEffect(() => {
        if (isSeekingDisabled) {
            if (isHovering)
                onMouseLeave();
            if (isGestureInProgress)
                onGestureEnded();
        }
    }, [isSeekingDisabled]);
    useEventListener('mousemove', onMouseMove, window);
    useEventListener('mouseup', onMouseUp, window);
    useEventListener('click', onClick, window);
    const onSlidingStart = () => {
        onSeekingStart();
        setIsChangingValue(true);
    };
    const onSlidingComplete = () => {
        onSeekingEnd();
        setIsChangingValue(false);
        dispatch(hideUI());
    };
    const onSliderMouseMove = ({ pageX }) => {
        if (isChangingValue)
            return;
        if (!parentElement || pageX === undefined)
            return;
        const { left, width } = parentElement.getBoundingClientRect();
        const progress = ((pageX - left) / width) * PERCENT;
        const progressInPercent = Math.max(0, Math.min(PERCENT, progress));
        setHoverProgress(progressInPercent);
    };
    return (React.createElement(Slider, { style: sliderStyle, "data-test": "SeekingManager-Container", value: value, onValueChange: onValueChange, enabled: !isSeekingDisabled, minimumValue: 0, maximumValue: 100, thumbStyle: thumbStyle, minimumTrackTintColor: "transparent", maximumTrackTintColor: "transparent", onMouseDown: onMouseDown, onMouseEnter: onHoverStart, onSlidingStart: onSlidingStart, onSlidingComplete: onSlidingComplete, onMouseMove: onSliderMouseMove, onMouseLeave: onMouseLeave }));
};
//# sourceMappingURL=index.js.map